
<div>
    <app-bar :title="t('premium_main_goals_title')"></app-bar>

    <template v-if="touchedGoal.exists()">
        <v-app-bar
            color="transparent"
            height="84"
            elevation="0"
            class="mb-n6 px-6"
        >
            <v-toolbar-title>{{ touchedGoal.title }}</v-toolbar-title>
            <v-btn
                @click="unset()"
                plain
                icon
                absolute
                right
                class="mr-n8"
            ><v-icon>mdi-close</v-icon></v-btn>
        </v-app-bar>

        <div class="px-10 pb-6 overflow-hidden">
            <user-main-goal-view :goal="touchedGoal"></user-main-goal-view>
        </div>
    </template>

    <v-layout>
        <template v-if="! touchedGoal.exists()">
            <user-main-goal-collection
                @touched="touch"
            ></user-main-goal-collection>
        </template>
    </v-layout>
</div>
